var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cq-layout-main"},[_c('CQHeaderAuth'),_c('div',{staticClass:"cq-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }